import axios from './request'
/**
 * 获取文章列表
 */
export function getarticles(params) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/h5web/bingo/h5/discovery/getarticles', {
  // return axios.post('https://pwa.tujia.com/feapi/h5web/bingo/h5/city/getarticles', {
    ...params
  })
}
